import { DateTime } from "luxon";

export default {
  methods: {
    getCalendars() {
      return fetch(this.api + "/api/node/calendar")

        // Get response from server.
        .then((response) => {
          return response.json();
        })

        // Return the data object.
        .then((response) => {
          return response.data;
        });
    },

    parseCalendarData(data) {
      let calendars = {};

      // Set calendar data.
      data.forEach((calendar) => {
        // Ensure cancer center calendar comes in checked.
        let checked = calendar.attributes.calendar_id == "med-cancer-center@umich.edu" ? true : false;

        // Add to calendars object.
        calendars[calendar.attributes.calendar_id] = {
          name: calendar.attributes.title,
          id: calendar.attributes.calendar_id,
          checked: checked
        };
      });

      return calendars;
    },

    /**
     * Returns all events from the API, I promise...
     *
     * @param {string} url
     * @param {array} events
     */
    getEvents(url, events = []) {
      return new Promise((resolve, reject) => fetch(url)

      .then(response => {
        response.json().then(data => {
          events = events.concat(data.data);

          if (data.links.next) {
            this.getEvents(data.links.next.href, events).then(resolve).catch(reject);
          }
          else {
            resolve(events);
          }
        }).catch(reject);
      }).catch(reject));
    },

    checkCalendarsStatus(calendars) {
      let localCalendars = JSON.parse(localStorage.getItem("umcancer-event-app-calendars"));

      if (localCalendars) {
        // Loop through calendars to see if any should be unchecked.
        Object.keys(localCalendars).forEach(key => {
          calendars[key].checked = localCalendars[key].checked;
        });
      }

      // Save calendars to localStorage.
      localStorage.setItem("umcancer-event-app-calendars", JSON.stringify(calendars));

      return calendars;
    },

    parseEventData(events) {
      // Fetch if the calendar is checked.
      events.forEach((event) => {
        const calendar = event.attributes.event_calendar;
        let day, dayWeek, year, end, month, start, monthInt, start24, description;

        // Calculate some date values.
        if (event.attributes.event_start_date) {
          day = DateTime.fromISO(event.attributes.event_start_date).toFormat("dd");
          dayWeek = DateTime.fromISO(event.attributes.event_start_date).toFormat("cccc");
          year = DateTime.fromISO(event.attributes.event_start_date).toFormat("yyyy");
          month = DateTime.fromISO(event.attributes.event_start_date).toLocaleString({ month: "long" });
          start = DateTime.fromISO(event.attributes.event_start_date).toLocaleString(DateTime.TIME_SIMPLE);
          end = DateTime.fromISO(event.attributes.event_end_date).toLocaleString(DateTime.TIME_SIMPLE);
          start24 = DateTime.fromISO(event.attributes.event_start_date).toFormat("T");
        }
        else {
          day = event.attributes.event_day;
          year = event.attributes.event_year;

          // Form a date iso to pass to luxon.
          const monthInt = event.attributes.event_month;
          const dateISO = year + monthInt + day;

          // Figure out day week and month from created ISO.
          dayWeek = DateTime.fromISO(dateISO).toFormat("cccc");
          month = DateTime.fromISO(dateISO).toLocaleString({ month: "long" });
        }
        if (event.attributes.event_description) {
          description = event.attributes.event_description.value;
        }

        // Add events to data object.
        this.events.push({
          expanded: false,
          active: true,
          id: event.attributes.drupal_internal__nid,
          title: event.attributes.title,
          location: event.attributes.event_location,
          allDay: event.attributes.event_all_day,
          calendar: event.attributes.event_calendar,
          ics: event.attributes.event_ics,
          description: description,
          startDate: event.attributes.event_start_date,
          endDate: event.attributes.event_end_date,
          day: day,
          dayWeek: dayWeek,
          year: year,
          end: end,
          month: month,
          start: start,
          start24: start24
        });
      });

    }

  }

}



// WEBPACK FOOTER //
// ./src/mixins.js